export default __webpack_public_path__ + "static/media/content.a1c21b9e.png";